// "Create a hike from this section": the planner picks the measured route section up
// from localStorage on load, the same hand-off the hike map's import already uses.

export const PLANNER_IMPORT_KEY = 'hikerPlannerImport';
export const PLANNER_PATH = '/hike-planner';

/** The planner's import payload for a measured section of [lng, lat, ele?] coordinates. */
export function plannerImportFor(coordinates: number[][]) {
  return {
    type: 'FeatureCollection',
    features: [{
      type: 'Feature',
      geometry: { type: 'LineString', coordinates },
      properties: { routeStyle: 'route' },
    }],
  };
}

/** Stores the section and opens the planner; false when storage is unavailable or the section is too short. */
export function createHikeFromSection(
  coordinates: number[][],
  storage: Pick<Storage, 'setItem'> | null = safeLocalStorage(),
  navigate: (path: string) => void = (path) => { window.location.href = path; },
): boolean {
  if (!storage || !coordinates || coordinates.length < 2) return false;
  try {
    storage.setItem(PLANNER_IMPORT_KEY, JSON.stringify(plannerImportFor(coordinates)));
  } catch (error) {
    return false;
  }
  navigate(PLANNER_PATH);
  return true;
}

export function safeLocalStorage(): Storage | null {
  try {
    return window.localStorage;
  } catch (error) {
    return null;
  }
}
